
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Validate')]),_c('path',{staticClass:"cls-2",attrs:{"d":"M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM615.83,282.57,384.16,543.37,362,570.91a7.45,7.45,0,0,1-10.48,1.14l-.48-.38a9.47,9.47,0,0,1-3-1.78l-7.23-6.42L184.6,437.92a7.45,7.45,0,0,1-1.14-10.48l40.77-50.74a7.44,7.44,0,0,1,10.47-1.14l111.77,89.78L556,229.44a9.34,9.34,0,0,1,13.18-.78l45.85,40.73A9.34,9.34,0,0,1,615.83,282.57Z"}}),_c('g',{staticClass:"cls-1"},[_c('rect',{attrs:{"x":"418.65","y":"198.31","width":"80","height":"401.94","rx":"9.34","ry":"9.34","transform":"translate(380.93 -203.83) rotate(41.62)"}}),_c('rect',{attrs:{"x":"253.13","y":"359.27","width":"80","height":"229.07","rx":"7.45","ry":"7.45","transform":"translate(846.09 542.02) rotate(128.78)"}})])])
          )
        }
      }
    